import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Home from "./home";
import Register from "./register";

const root = ReactDOM.createRoot(document.getElementById("root"));

const pathName = window.location.pathname.slice(1);
root.render(
  <React.StrictMode>
    {/* <App /> */}
    {pathName === "login" ? <Register /> : <Home />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
